import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { TestDto } from '../dto/TestDto';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiAddTest = async (
  section: string,
  route: string,
  keyTitle: string,
  dto: TestDto
) => {
  const params: IApiParams = {
    url: `/admin/addTest.php?section=${section}&route=${route}&keyTitle=${keyTitle}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
